// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://beverlyhillsmd.com";
export const CDN_BASE_URL = "https://cdn.beverlyhillsmd.com";
export const CART_BASE_URL = "https://cart.beverlyhillsmd.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6058004204001";
export const ONE_SHOPPING_CART_URL = "https://www.1shoppingcart.com";
export const LEGAL_BASE_URL = "https://legal.beverlyhillsmd.com";

// External Service URLs
export const EXTERNAL_URLS = {
  PAYPAL_BUTTON: "assets/img/paypalButton.jpg",
  PAYPAL_BUTTON_LARGE: "assets/img/paypalButton-lg.jpg"
};

export const CUSTOMER_SERVICE_PHONE_NUMBER = '(877)828-5528';

// CDN Image URLs
export const CDN_IMAGES = {
  BIOC_COMPLETE3_SUPP: `${CDN_BASE_URL}/images/bio-complete-3/BioComplete3-supp.png`,
  BLUE_CHECK: `${CDN_BASE_URL}/images/blue_check.png`,
  BODY: `${CDN_BASE_URL}/img/drLaykeBack.jpg`,
  BOTTOM_CORNER: `${CDN_BASE_URL}/images/gundry-bottom-corner.png`,
  CHECKOUT_90DAY: `${CDN_BASE_URL}/images/BHMD-90Day-Badge.png`,
  CHECKOUT_60DAY: `${CDN_BASE_URL}/images/BHMD-60Day-Badge.png`,
  CHECKOUT_TRUCK: `${CDN_BASE_URL}/images/shippingTruckTC.png`,
  FACEBOOK: `${CDN_BASE_URL}/img/facebookIcon.jpg`,
  FIELD_DESKTOP: `${CDN_BASE_URL}/images/Field_Desktop.png`,
  GRAY_CHECK: `${CDN_BASE_URL}/images/gray_check2.png`,
  HEALTH_IMAGE: `${CDN_BASE_URL}/images/5c1e24a802aa7adbf71d89a06ddb417581fa46ea.jpg`,
  INSTAGRAM: `${CDN_BASE_URL}/img/instagramIcon.jpg`,
  LOGO: `${CDN_BASE_URL}/images/logo-beverlyhillsmd.svg`,
  LOGO_CIRCLE: `${CDN_BASE_URL}/images/logo-circle.png`,
  LOGO_FOOTER: `${CDN_BASE_URL}/img/BHMDLogoFooter.png`,
  LOGO_SHORT: `${CDN_BASE_URL}/images/GundryMD-Logo_short.png`,
  LOCK_ICON: `${CDN_BASE_URL}/images/lock-white.svg`,
  GIFT_ICON: `${CDN_BASE_URL}/images/gift-icon.png`,
  CALENDAR_ICON: `${CDN_BASE_URL}/images/calendar-04.png`,
  HEART_ICON: `${CDN_BASE_URL}/images/heart.png`,
  TRY_FREE_ICON: `${CDN_BASE_URL}/images/try-free.png`,
  TRY_JAR_ICON: `${CDN_BASE_URL}/images/try-jar.png`,
  TRY_RENEW_ICON: `${CDN_BASE_URL}/images/try-renew.png`,
  RETURN_ICON: `${CDN_BASE_URL}/images/return-request.png`,
  CHEVRON_DOWN_ICON: `${CDN_BASE_URL}/images/chevron-down.png`,
  MONEYBACK_GUNDRY: `${CDN_BASE_URL}/images/moneyback-gundry.png`,
  LOGO_WHITE: `${CDN_BASE_URL}/images/BHMD_logo_word_white.png`,
  MYACCOUNT_CHECKMARK: `${CDN_BASE_URL}/images/Myaccount-checkmark-sign-up.png`,
  PALM_WAIT: `${CDN_BASE_URL}/images/palm_wait.svg`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  PHONE2: `${CDN_BASE_URL}/images/phone2.png`,
  PRIVACY_POLICY: `${LEGAL_BASE_URL}/privacy-policy/`,
  RED_CHECK: `${CDN_BASE_URL}/images/red-check.png`,
  SCRUBS: `${CDN_BASE_URL}/img/drLaykeBack.jpg`,
  SCRUBS_GREEN: `${CDN_BASE_URL}/img/drLaykeBack.jpg`,
  SPINNING_WHEEL_CIRCLES: `${CDN_BASE_URL}/images/spinning-wheel-small_circlesfull.png`,
  SPINNING_WHEEL_TRIANGLE: `${CDN_BASE_URL}/images/spinning-wheel-triangle.png`,
  STAR_GREEN: `${CDN_BASE_URL}/1starGreen.png`,
  SUBSCRIPTION_TERMS: `${CDN_BASE_URL}/terms/beverlyhillsmd-terms.html`,
  TERMS_AND_CONDITIONS: `${LEGAL_BASE_URL}/terms`,
  UNITS_SOLD: `${CDN_BASE_URL}/images/unitsSoldTC.png`,
  UP_NO: `${CDN_BASE_URL}/images/upNo.jpg`,
  UP_NO_MOBILE: `${CDN_BASE_URL}/images/upNo_mobile.jpg`,
  UP_YES: `${CDN_BASE_URL}/images/upYes.jpg`,
  UP_YES_MOBILE: `${CDN_BASE_URL}/images/upYes_mobile.jpg`,
  X: `${CDN_BASE_URL}/img/twitterIcon.jpg`
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
